<template>
  <div id="contact">
    <!--HEADER-->
    <header class="header--small"></header>
    <!-- SECTION-->
    <section class="section mt-5">
      <mdb-container>
        <mdb-row>
          <mdb-col class="d-flex justify-content-center">
            <h2 class="section__heading">Contact</h2>
          </mdb-col>
          <div class="w-100"></div>
          <mdb-col class="d-flex justify-content-center">
            <h3 class="section__sub-heading">We'd love to hear from you.</h3>
          </mdb-col>
        </mdb-row>
        <form action="#" novalidate @submit.prevent="sendMessage">
          <mdb-row class="mt-4 justify-content-center">
            <mdb-col md="8">
              <mdb-row>
                <mdb-col md="6">
                  <mdb-input
                    type="text"
                    placeholder="Name"
                    outline
                    required
                    v-model="name"
                  />
                </mdb-col>
                <mdb-col>
                  <mdb-input
                    type="text"
                    label="Company"
                    outline
                    v-model="company"
                  />
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col md="6">
                  <mdb-input
                    type="text"
                    label="Phone"
                    outline
                    required
                    v-model="phone"
                  />
                </mdb-col>
                <mdb-col>
                  <mdb-input
                    type="text"
                    label="E-Mail"
                    outline
                    v-model="email"
                  />
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col>
                  <mdb-input
                    type="textarea"
                    v-model="message"
                    placeholder="Message"
                    outline
                    required
                    :rows="6"
                  ></mdb-input>
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col>
                  <div class="form-check pl-1">
                    <input
                      type="checkbox"
                      id="filledInCheckbox"
                      v-model="termsAndPrivacyRulesAccepted"
                      class="form-check-input filled-in"
                      required
                    />
                    <label class="form-check-label" for="filledInCheckbox">
                      Agree on
                      <a href="/data-privacy" target="_blank" class="link"
                        >Data Privacy Rules</a
                      >
                      and terms and conditions.
                    </label>
                  </div>
                  <p class="mt-4 text-danger" v-show="errorMessage">
                    {{ errorMessage }}
                  </p>
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col>
                  <mdb-btn class="btn btn-isi mt-4 mb-5 ml-0" type="submit"
                    >Send</mdb-btn
                  >
                </mdb-col>
              </mdb-row>
            </mdb-col>
          </mdb-row>
        </form>
      </mdb-container>
    </section>
    <!-- ./SECTION-->
    <app-footer />
  </div>
</template>

<script>
import AppFooter from "../components/Footer.vue";
import { mdbSmooth } from "mdbvue";
export default {
  components: { AppFooter },
  directives: {
    mdbSmooth,
  },
  name: "Contact",
  data() {
    return {
      name: "",
      company: "",
      phone: "",
      email: "",
      message: "",
      termsAndPrivacyRulesAccepted: false,
      errorMessage: "",
    };
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Contact",
    // all titles will be injected into this template
    titleTemplate: "%s | isi Test Studio Finder",
  },
  methods: {
    resetInput() {
      this.name = "";
      this.company = "";
      this.phone = "";
      this.email = "";
      this.message = "";
      this.errorMessage = "";
      this.termsAndPrivacyRulesAccepted = false;
    },
    sendMessage() {
      this.$http({
        method: "post",
        url: "/api/Contact",
        data: {
          senderName: this.name,
          senderCompany: this.company,
          senderPhone: this.phone,
          senderEmail: this.email,
          message: this.message,
          termsAndPrivacyRulesAccepted: this.termsAndPrivacyRulesAccepted,
        },
      })
        .then((rsp) => {
          if (rsp?.data?.err) {
            this.errorMessage = rsp.data.err;
          } else {
            this.$store.commit("setCurrentModal", {
              type: "GeneralInfoModal",
              options: {
                title: "Message sent",
                content: "Your message has been successfully submitted.",
              },
            });
            this.resetInput();
          }
        })
        .catch(() => {
          this.$store.commit("setCurrentModal", {
            type: "GeneralInfoModal",
            options: {
              title: "Your message could not be sent",
              content:
                "Your message could not be sent. Please contact as with the given information at the 'Legal Notice' page.",
            },
          });
        });
    },
  },
};
</script>

<style lang="scss">
@import "~@/styles/parts/_section.scss";
@import "~@/styles/views/_headers.scss";
</style>